module.exports = __webpack_public_path__ + "media/InjectionMolder_IN.e53d0fd5.mp4";